<app-util-visitor-parts-treatment-others-list-items
                            [visitor]="visitor"
                            [archived]="archived"
                            [limit]="limit"
                            (updateEvent)="update()"
                            #utilVisitorPartsTreatmentOthersListItems></app-util-visitor-parts-treatment-others-list-items>